export default{
    // apiURL: "http://127.0.0.1:8000/api",
    apiURL: "http://localhost/kisda/student/backend/public/api",
    // apiURL: "https://kisda.online/api-student/api"

}